import { fetchWithoutAuth } from './fetchWithoutAuth';
import { ApplicationSubmission } from '../../types/application';

export async function submitApplication(applicationData: ApplicationSubmission) {
  return fetchWithoutAuth('/api/public/apply', {
    method: 'POST',
    body: JSON.stringify(applicationData),
  });
} 